/*

fileName:
_/i + s/c/h + v/t/c/f/b/r/n + Name

_: common
i: individual

s: server side
c: client side
d: device dependent
h: hyblid
r: replaced

i: index
v: constatnt value
t: type
c: component without function
f: function without import
b: function without react import and node import
m: function with react or node import or component
s: state

b: base
c: composit

variableName

g/v/p/s/_ + n/s/l/d/f/p + Name(s)

g: global variable
v: view variable
p: function parameter
s: state variable
_: local variable

n: number
s: string
l: list
d: dictionary
f: function
p: promise

cmnz: save at and load from local storage
pagez: load every pages

 */

import * as _ht from './_ht';

export const e = ( paVle: _ht.a ) => { // entries
  if (chkType(paVle, 'd')) {
    return Object.keys(paVle).entries()
  }
  else if (chkType(paVle, 'l')) {
    return paVle.entries()
  }
  else {
    return [];
  }
};

export const f = (
  vle: _ht.a
) => {
  if (vle == null) {
    return false;
  }
  else if (vle == undefined) {
    return false;
  }
  else {
    if (chkType(vle, 'd')) {
      if (Object.keys(vle).filter((_key: _ht.s) => vle[_key] ? true : false).length == 0) { // 値が null の key を考慮
        return false;
      }
      else {
        return true;
      }
    }
    else if (chkType(vle, 'l')) {
      if (vle.length == 0) {
        return false;
      }
      else {
        return true;
      }
    }
    else {
      if (vle == '') {
        return false;
      }
      else if (vle == 'None') {
        return false;
      }
      else if (vle == 'null') {
        return false;
      }
      return true;
    }
  }
};

export const gt = (nbr1: _ht.n | undefined, nbr2: _ht.n) => { // greater than
  return (nbr1 || nbr1 == 0) && (nbr2 || nbr2 == 0) && nbr1 > nbr2
};

export const i = (
  pVle: _ht.s | _ht.n, 
  pVles: (_ht.s | _ht.n)[]
) => {
  if (pVles.indexOf(pVle as never) >= 0) return true;
  return false;
};

export const j = (vle:  _ht.s) => { // convert string to json
  if (vle) {
    try {
      return JSON.parse(vle);
    }
    catch (_err) {
      return null
    } 
  }
  else {
    return null
  }
};

export const l = (vle: _ht.s) => { // log
  console.log(vle);
};

export const n = (
  paVle: _ht.n | _ht.s
) => {
  return (f(paVle)) ? Number(String(cvtHkk(paVle)).replace(/,/g, '')) : 0;
};

export const nn = ( // not null
  ls: _ht.ls
) => {
  return ls ? ls.filter((_a: _ht.a) => f(_a)) : [];
}

export const nd = ( // not delete
  Ss: _ht.ls,
  tgt?: _ht.s
) => {
  const _ls = 
    tgt ?
      Ss.filter((_Sz: _ht.dz) => _Sz[tgt] && _Sz[tgt]._dlt != 1 && _Sz[tgt]._dus != 1)
    : Ss.filter((_Sz: _ht.dz) => _Sz && _Sz._dlt != 1 && _Sz._dus != 1);
  return _ls;
}

export const q = (
  pElm: _ht.s, 
  pAjtz?: _ht.dz
) => {
  return {
    qryCnt: (_dz: _ht.dz) => ({
      elm: pElm,
      cdn: `_dmn = ${_dz._02r._key} AND _show = 1`,
      prmz: {}, 
      fld: 'count(*) as cnt',
    }),
    qryTop: (_dz: _ht.dz) => ({
      elm: pElm,
      cdn: `_dmn = ${_dz._02r._key} AND COALESCE(_dlt,-1) = -1`,
      tail: `ORDER BY ${_dz.odr ?? '_key'} LIMIT ${_dz.lmt ?? 999} OFFSET ${_dz.ost ?? 1}`, 
      prmz: {}, 
      fld: '_key, _id, _name, _type, _ctn, _show',
    }),
    qryCtt: (_dz: _ht.dz) => ({
      elm: pElm,
      cdn: `_dmn = ${_dz._02r._key} AND _key = ${_dz._key}`,
      prmz: {}, 
      fld: 'all',
    }),
    ...pAjtz,
  }
};

export const s = (vle: _ht.a) => { // convert json to string
  const _rcr = (_key: _ht.a, _vle: _ht.a) => {
    if ( chkType(_vle, 'f')) {
      return _vle.toString();
    }
    return _vle;
  };
  return JSON.stringify(vle, _rcr);
};

export const agt = (pz: {// aggregate
  ls: _ht.dz[],
  keyFldName?: _ht.s,
  grtKey: (_dz: _ht.dz) => _ht.s, // field
  clts: { // calculate
    mode: 'sum' | 'avg' | 'cnt' | 'max' | 'min',
    vleFldName: _ht.s,
    grtVle?: (_dz: _ht.dz) => _ht.n,
  }[],
}): _ht.dz[] => {
  const _keyFld = pz.keyFldName ?? 'key';
  const _dz2 = {} as _ht.dz;
  if (pz.ls) Array.from(pz.ls)?.map(_dz => {
    const _key = pz.grtKey(_dz);
    if (pz.clts) Array.from(pz.clts)?.map(cltz => {
      const _n_vle = cltz.grtVle ? cltz.grtVle(_dz) : 0;
      const _mode = cltz.mode;
      //hf.l('hf 381: {}, {}'.f(cltz.mode, _n_vle));
      if (f(_n_vle) || _n_vle == 0 || _mode == 'cnt') {
        if (f(_dz2[_key]) == false) {
          _dz2[_key] = {};
        }
        const _vleFld = cltz.vleFldName ?? 'nVle';
        if (f(_dz2[_key][_vleFld]) == false) {
          _dz2[_key][_vleFld] = {
            mode: _mode,
            n_sum: 0, 
            n_cnt: 0, 
            n_avg: 0,
            n_max: -999999999,
            n_min:  999999999,
          };
        }
        const _n_sum = _dz2[_key][_vleFld].n_sum + _n_vle;
        const _n_cnt = _dz2[_key][_vleFld].n_cnt + 1;
        const _n_avg = _n_sum / _n_cnt;
        const _n_max = (_n_vle > _dz2[_key][_vleFld].n_max) ? _n_vle : _dz2[_key][_vleFld].n_max;
        const _n_min = (_n_vle < _dz2[_key][_vleFld].n_min) ? _n_vle : _dz2[_key][_vleFld].n_min;
        _dz2[_key][_vleFld] = {
          mode: _mode,
          n_sum: _n_sum,
          n_cnt: _n_cnt,
          n_avg: _n_avg,
          n_max: _n_max,
          n_min: _n_min,
        };
      }
    })
  });
  const _l2: _ht.dz[] = [];
  Object.keys(_dz2).map(_key => {
    const _d: _ht.dz = {
      [_keyFld]: _key,
    };
    Object.keys(_dz2[_key]).map(_vleFld => {
      const _mode = _dz2[_key][_vleFld].mode;
      _d[_vleFld] = 
        _mode == 'sum' ?
          _dz2[_key][_vleFld].n_sum
        : _mode == 'avg' ?
          _dz2[_key][_vleFld].n_avg
        : _mode == 'cnt' ?
          _dz2[_key][_vleFld].n_cnt
        : _mode == 'max' ?
          _dz2[_key][_vleFld].n_max
        : _mode == 'min' ?
          _dz2[_key][_vleFld].n_min
        : null;
      //hf.l('hf 432: {}, {}, {}'.f(_vleFld, _mode, _d[_vleFld]));
    })
    _l2.push(_d)
  });
  return _l2;
};

export const chkHkk = (vle: _ht.s, bEisu?: _ht.b) => {
  const _ptn = bEisu ? /^[A-Za-z0-9]*$/ : /^[\x20-\x7e]*$/;
  return (vle.match(_ptn)) ? true : false;
}

export const chkType = (
  vle: _ht.a, 
  type: 'd' | 'l' | 'n' | 's' | 'f'
) => {
  switch (type) {
    case 'd':
      return getType(vle) == 'object' ? true : false;
    case 'l':
      return getType(vle) == 'array' ? true : false;
    case 'n':
      return getType(vle) == 'number' ? true : false;
    case 's':
      return getType(vle) == 'string' ? true : false;
    case 'f':
      return getType(vle) == 'function' ? true : false;
    default:
      return false;
  }
};

export const clrLs = ( // clezr array
  ls: _ht.ls
) => {
  ls.splice(0);
};

export const clrDz = ( // clear dictionary
  dz: _ht.dz
) => {
  Object.keys(dz).map((key: _ht.s) => {
    delete dz[key];
  });
};

export const clw = ( // clock work
  msc: _ht.n, // milli second
  ftn: () => _ht.b
) => new Promise( _exit => { // clock work
  const _id = setInterval(()=>{
    if (ftn()) {
      clearInterval(_id);
      _exit(true);
    }
  }, msc)
});

export const cvtCeil = (
  pnVle: _ht.n, 
  pnPwr?: _ht.n
): _ht.n => {
  const _nPwr = pnPwr ?? 1;
  return Math.ceil(pnVle / _nPwr) * _nPwr;
};

export const cvtCmm = (
  pnVle: _ht.n,
): _ht.s => {
  const [_s1, _s2] = String(pnVle).replace(/,/g, '').split('.');
  let _rst = String(_s1).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  if (_s2) _rst += '.' + _s2;
  return _rst;
};

export const cvtEml = ( // email
  vle: _ht.s
) => {
  return trimBlk(cvtLwr(cvtHkk(vle)));
};

export const cvtFlr = (
  vle: _ht.n, 
  pwr?: _ht.n
): _ht.n => {
  const _pwr = pwr ?? 1;
  return Math.floor(vle / _pwr) * _pwr;
};

export const cvtHkk = ( // hankaku
  vle: _ht.n | _ht.s
) => {
  return String(vle).replace(/[Ａ-Ｚａ-ｚ０-９]/g, (_s) => String.fromCharCode(_s.charCodeAt(0) - 65248));
};

export const cvtHash = (
  srg: _ht.s
) => {
  return srg.split('').map( _c => _c.charCodeAt(0) ).reduce((_a, _v) => _a+((_a<<7)+(_a<<3))^_v).toString(16);
};

export const cvtLsToDz = (
  ls: _ht.ls,
  grtKey: (_dz: _ht.dz) => _ht.s
) => {
  const _dz = {} as _ht.dz;
  ls.map( ( _dz2: _ht.dz ) => {
    _dz[grtKey(_dz2)] = _dz2;
  });
  return _dz;
}

export const cvtLsToDzLs = (
  ls: _ht.ls,
  grtKey: (_dz: _ht.dz) => _ht.s
) => {
  const _dz = {} as _ht.dz;
  ls.map( ( _dz2: _ht.dz ) => {
    const _key = grtKey(_dz2);
    if (!_dz[_key]) _dz[_key] = [] as _ht.ls;
    _dz[_key].push(_dz2);
//l(`hf 391: ${_key}, ${s(_dz2)}`)
  });
//l(`hf 392: ${s(_dz)}`)
  return _dz;
}

export const cvtLwr = ( // lower
  vle: _ht.s
) => {
  return String(vle).toLowerCase();
};

export const cvtNbr = (
  mode: 'e' | 'd', // encode, decode
  vle: _ht.n | _ht.s,
  srtz?: {
    code: _ht.s,
    geta: _ht.n, // 想定よりも 1 桁多く、頭が8以下の数を設定
  },
) => {
  const _code = srtz?.code ?? '0123456789';
  const _geta = srtz?.geta ?? 0;
  //l(`hf 375: ${_code} ${_geta}`)
  if (mode == 'e') {
    let _r = '';
    const _tgt = String(Number(vle) + _geta);
    const _cnt = _tgt.length;
    getRng(_cnt).map((_idx: _ht.n) => {
      const _n = (_cnt - _idx) as _ht.n;
      const _s = _tgt[_n];
      _r += _code[Number(_s)]
//l(`hf 382: ${_idx}, ${_n}, ${_tgt}, ${_r}`)
    });
    return _r;
  }
  else {
    let _r = '';
    const _tgt = String(vle);
    const _cnt = _tgt.length;
    getRng(_cnt).map((_idx: _ht.n) => {
      const _n = (_cnt - _idx) as _ht.n;
      const _s = _tgt[_n];
      _r += String(_code.indexOf(_s));
    });
    return Number(_r) - _geta;
  }
};

export const copyDz = (dz: _ht.dz) => {
  return j(s(dz));
}

export const ectSrlAsync = ( // execute in serial
  asyncs: _ht.ls
): Promise<_ht.b> =>  new Promise( _exit1 => {
  const _async = asyncs.shift();
  //l(`446: ${_async}`)
  if (_async) {
    _async()
    .then( async (_rst1: _ht.b) => {
      if (_rst1 != false) {
        let _rst2 = true;
//        if (f(asyncs)) _rst2 = await ectSrlAsync(asyncs);
        if (asyncs && asyncs.length > 0) _rst2 = await ectSrlAsync(asyncs);
        _exit1(_rst1 && _rst2);
      }
      else {
        _exit1(false);
      }
    });
  }
  else {
    _exit1(false);
  }
});

export const ectPrlAsync = async ( // execute in pararell
  ftns: _ht.ls // promise の列挙
) => {
  const _bs = await Promise.all(ftns.filter((ftn: _ht.o) => ftn).map((ftn: _ht.o) => ftn())) // Promise.all において関数は実行されない
  let _b = true;
  _bs.map((_b2: _ht.b) => {
    if (_b2 == false) _b = false;
  });
  return _b;
};

export const fmt = ( // tgt を prmz の rlcz でリプレース
    pTgt?: _ht.s,
    pVlez?: _ht.dz,
    pPrmz?: _ht.dz, // replace
) => {
  let _tgt = pTgt;
  if (pTgt && pVlez && pPrmz) {
    Object.keys(pPrmz).map( _key => {
      const [_als, _fld] = String(pPrmz[_key]).split('.');
      const _vle = pVlez[_als][_fld];
      _tgt = _tgt?.replace(new RegExp(`\\{${_key}\\}`, 'g'), _vle)
      //l(`hf 256: key:${_key}, als:${_als}, fld:${_fld}, vle:${_vle}, tgt:${_tgt}`);
    });
  }
  return _tgt;
};

export const forAwaitAsync = async ( pLs: _ht.ls, pfAsync: ( paVle: _ht.a, pnIdx?: _ht.n ) => void ) => {
  for await ( const [_nIdx, _aVle] of e(pLs) ) {
    await pfAsync(_aVle, _nIdx);
  }
}

export const getLs1 = (ls: _ht.ls, itl?: _ht.a) => f(ls) ? ls[0] : (itl ?? undefined); 
export const get1 = getLs1;

export const getFlds = (dz?: _ht.dz) => dz ? Object.keys(dz) : []; 

export const getRdm = (max: _ht.n) => {
  return Math.floor(Math.random() * (n(max) + 1));
};

export const getRng = (
  pnTo: _ht.n, 
  pnFrom?: _ht.n, 
) => {
  const _nFrom = pnFrom ?? 1;
  return ((pnTo - _nFrom + 1) >= 1) ? Array.from(new Array(pnTo - _nFrom + 1)).map((_vle, _idx) => _idx + _nFrom) : [];
};

export const getSrg = ( // get string
  srg: _ht.s, 
  from: _ht.n, 
  to: _ht.n
) => {
  return srg.slice(from, to - from + 1);
};

export const getSrgByte = (
  s: _ht.s,
) => {
  return Math.min((new Blob([s])).size,2); // 絵文字などで Blob.size = 4 なる場合などへの対応
}

/*
export const getSrgByByte = ( // get string by byte
  srg: _ht.s, 
  from: _ht.n, 
  to: _ht.n
) => {
  let _r = '';
  let _cnt = 0;
  srg.split('').map((_srg: _ht.s) => {
    const _len = encodeURIComponent(_srg).replace(/%../g,"x").length;
    if (_len == 1) {
      _cnt += 1;
    }
    else {
      _cnt += 2;
    }
    if (from <= _cnt && _cnt <= to) {
      _r += _srg;
    }
  });
  return _r;  
};
*/
export const getSrgByByte = ( // get string by byte
  srg: _ht.s,
  from: _ht.n,
  to: _ht.n,
  dtn?: 'l' | 'r',
) => {
  let _r = '';
  let _cnt = 0;
  if (dtn != 'r') {
    srg?.split('').map((_srg: _ht.s) => {
      const _len = getSrgByte(_srg);
      if (_len == 1) {
        _cnt += 1;
      }
      else {
        _cnt += 2;
      }
      if (from <= _cnt && _cnt <= to) {
        _r = _r + _srg;
      }
    });
  }
  else {
    srg?.split('').reverse().map((_srg: _ht.s) => {
      const _len = getSrgByte(_srg);
      if (_len == 1) {
        _cnt += 1;
      }
      else {
        _cnt += 2;
      }
      if (from <= _cnt && _cnt <= to) {
        _r = _srg + _r;
      }
    });
  }
  return _r;
};

export const getSrgBySrg = ( // get string by string
  srg: _ht.s, 
  from: _ht.s, 
  to: _ht.s
) => {
  let _from = srg.indexOf(from);
  if (_from < 0) _from = -1;
  let _to = srg.indexOf(to);
  if (_to < 0) _to = srg.length;
  return srg.substring(_from + 1, _to);
};

export const getType = (
  paVle: _ht.a
): string => {
  return Object.prototype.toString.call(paVle).slice(8, -1).toLowerCase();
};

export const getDz = ( // get dz from ls
  pLs: _ht.dz[],
  pVle: _ht.s | _ht.n,
  pFld?: _ht.s,
): _ht.dz | undefined => {
  const _fld = pFld ?? '_key';
  let _r = undefined;
  pLs?.map( (_dz: _ht.dz) => {
    if (_dz && _dz[_fld] == pVle) _r = _dz;
  });
  return _r;
};

export const grtLs = ( // generate unique list
  ls: _ht.ls,
  key: _ht.s
) => {
  return [... new Set(ls.map((_dz: _ht.dz) => _dz[key]))];
};

export const grtUriPmr = (pz: _ht.dz) => { // generate uri parameter
  const _s = Object.keys(pz).map((_key: _ht.s) => `${_key}=${pz[_key]}`).join('&')
  return _s ? ('?' + _s) : undefined;
};

export const join = (ls?: _ht.ls, dtr?: _ht.s, pts?: _ht.s) => { // delimiter, parenthesis
//  return ls?.filter((_s: _ht.s) => f(_s)).join(dtr ?? `,`) ?? '';
  const _pts = pts ?? '';
  const _dtr = _pts + (dtr ?? ',') + _pts;
  return _pts + (ls?.filter((_s: _ht.s) => f(_s)).join(_dtr) ?? '') + _pts;
}

export const logOst = (ftnName: _ht.s) => {
  l('廃止：' + ftnName);
};

export const pdg = ( // padding
  vle: _ht.s | _ht.n, 
  cnt: _ht.n,
  pdg?: _ht.s
) => { // padding
  const _pdg = pdg ?? '0';
  return (_pdg.repeat(cnt) + String(vle)).slice(-cnt);
};

export const sfl = ( // shuffle
  ls: _ht.ls
) => {
  const _ls = ls.concat();
  getRng(_ls.length).map((_i: _ht.n) => {
    swap(_ls, _i-1, getRdm(_ls.length - 1));
  })
  return _ls;
};

export const slcByNbr = (ls: _ht.ls, cnt: _ht.n) => {
  return getRng(cvtCeil(ls.length / cnt), 1).map((_nbr: _ht.n) => ls.slice((_nbr - 1) * cnt, (_nbr -1 + 1) * cnt));
};

export const sort = (
  pLs: _ht.ls,
  pFld?: _ht.s,
  pDtn?: 'asg' | 'dsg', // asg: ascending, dsg: descending
) => {
  const _fld = pFld ?? '_icn';
  const _nVle1 = (pDtn == 'dsg') ? -1 :  1;
  const _nVle2 = _nVle1 * -1;
  return pLs.concat().sort( (_dz1, _dz2) => {
    if (_dz1[_fld] > _dz2[_fld] ) return _nVle1;
    if (_dz1[_fld] < _dz2[_fld] ) return _nVle2;
    return 0;
  });
};

export const swap = (
  ls: _ht.ls, 
  idx1: _ht.n, 
  idx2: _ht.n,
) => {
  [ls[idx1], ls[idx2]] = [ls[idx2], ls[idx1]];
};

export const trimBlk = ( // trim blank
  vle: _ht.s
) => {
  return String(vle).replace(/\s+/g, '');
};

export const udtDz = (
  pz1: _ht.dz, 
  pz2?: _ht.dz
) => {
  if (!pz2) {
    return pz1;
  }
  else {
    Object.keys(pz2).map( (_fld: _ht.s) => {
      pz1[_fld] = pz2[_fld];
    });
    return pz1;
  }
}

export const waitAsync = (
  msd: _ht.n,
) => new Promise(_exit1 => {
  setTimeout(_exit1, msd);
});
